import { IconSearch } from "@tabler/icons-react";
import { Card, Heading, Input, Select, Stack } from "@/components/ui";

/**
 * Filtros del listado de usuarios · se aplican en el SERVIDOR (el container
 * los pasa como query params). El filtro de organización manda el ID (no el
 * nombre) · las opciones vienen del catálogo completo de organizaciones.
 */
export function UsuariosFiltros({
  texto,
  onTextoChange,
  rol,
  onRolChange,
  rolesDisponibles,
  org,
  onOrgChange,
  organizaciones,
}: {
  texto: string;
  onTextoChange: (t: string) => void;
  rol: string;
  onRolChange: (r: string) => void;
  rolesDisponibles: string[];
  org: string;
  onOrgChange: (o: string) => void;
  organizaciones: { value: string; label: string }[];
}) {
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Heading order={5}>Filtros</Heading>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <Input
            label="Buscar"
            placeholder="email o nombre…"
            leftSection={<IconSearch size={14} stroke={1.7} />}
            value={texto}
            onChange={(e) => onTextoChange(e.currentTarget.value)}
          />
          <Select
            label="Rol"
            options={[{ value: "", label: "Todos" }, ...rolesDisponibles.map((r) => ({ value: r, label: r }))]}
            value={rol}
            onValueChange={onRolChange}
          />
          <Select
            label="Organización"
            options={[{ value: "", label: "Todas" }, ...organizaciones]}
            value={org}
            onValueChange={onOrgChange}
            searchable
          />
        </div>
      </Stack>
    </Card>
  );
}
